// Dropdown: Tag List
// eg. Interests: Fashion, Sport
// 

JLM.MD.DropdownTags = function( fieldset, data_list ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let legend_tally, dropdown, tags_list, tags_options, popout;
	
	// Settings
	let tags = [],
		tags_by_value = {},
		options = [],
		options_by_value = {};
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.value = [];
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let legend, legend_toggle, tags_range, footer, footer_close;
		
		// Fetch references
		legend = $('legend', fieldset);
		legend_tally = $('.tally', legend);
		legend_toggle = $('.toggle', legend);
		dropdown = $('.dropdown_tags', fieldset);
		tags_list = $('.dd_display ul', dropdown);
		popout = $('.dd_values', dropdown);
			tags_range = $('.dd_range', popout);
			tags_options = $('ul', tags_range);
			footer = $('.dd_footer', popout);
				footer_close = $('button', footer);
		
		// Build list of options
		data_list.forEach(function( entry ) {
			// Create option
			let option = new JLM.MD.DropdownTagsOption( tags_options, entry.label, entry.value );
			options.push( options );
			options_by_value[ entry.value ] = option;
			
			// Events
			option.on('select', addTag);
			option.on('deselect', removeTag);
		});
		
		// Events
		legend_toggle.on('click', toggle);
		tags_range.on('mousewheel', JLM.MT.preventScrollOverflow);
		footer_close.on('click', close);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Open and Close
	// 
	function open() {
		dropdown.attr('data-status', 'open');
		setTimeout(function() {
			$('body').on('click', onClickOutside);
		}, 10);
	}
	function close() {
		dropdown.attr('data-status', 'closed');
		$('body').off('click', onClickOutside);
	}
	function toggle() {
		if ( dropdown.attr('data-status') == 'closed' ) {
			open();
		} else {
			close();
		}
	}
	
	
	// Event Clicks
	// 
	function onClickOutside( event ) {
		if ( !$(event.target).closest( popout ).length ) {
			close();
		}
	}
	
	
	// Add Tag
	// 
	function addTag( label, value, prevent_bubbling ) {
		// Create tag
		let tag = new JLM.MD.DropdownTagsTag( tags_list, label, value );
		tag.on('remove', function() {
			removeTag( value );
		});
		tags_by_value[ value ] = tag;
		
		// Add to value
		INSTANCE.value.push( value );
		
		// Select option
		$('li[data-value="' + value + '"]', tags_options).addClass('selected');
		
		// Update tally
		legend_tally.html( INSTANCE.value.length );
		
		// Announce change
		if ( !prevent_bubbling ) INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
	}
	
	
	// Remove Tag
	// 
	function removeTag( value, prevent_bubbling ) {
		if ( tags_by_value[ value ] ) {
			// Remove tag
			tags_by_value[ value ].remove();
			
			// Remove from value
			var index = INSTANCE.value.indexOf( value );
			if ( index >= 0 ) INSTANCE.value.splice(index, 1);
			
			// Deselect option
			$('li[data-value="' + value + '"]', tags_options).removeClass('selected');
			
			// Update tally
			legend_tally.html( INSTANCE.value.length );
			
			// Announce change
			if ( !prevent_bubbling ) INSTANCE.dispatchEvent('change', [ INSTANCE.value ]);
		}
	}
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};